import keyBy from 'lodash-es/keyBy.js';
import { BendDirection, RawMaterial } from '../__generated/model/index.js';
import { round } from '../util/round.js';
const minFlangeLengthFactor = 1.1;
const calculateMinFlangeLength = (thickness)=>round(thickness * minFlangeLengthFactor, 2);
const calculateMinTongueLength = (thickness, internalRadius)=>2.5 * thickness + internalRadius;
const ninetyDegreeBendTools = [
    {
        // 0.55 uses the 0.7 die row from the calculator workbook.
        thickness: 0.55,
        innerRadius: 0.7,
        minFlangeLength: calculateMinFlangeLength(2.8),
        maximumLength: 800,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 0.7,
        innerRadius: 0.7,
        minFlangeLength: calculateMinFlangeLength(2.8),
        maximumLength: 800,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        // 0.9 uses the 1.0 die row.
        thickness: 0.9,
        innerRadius: 1,
        minFlangeLength: calculateMinFlangeLength(4),
        maximumLength: 800,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 1,
        innerRadius: 1,
        minFlangeLength: calculateMinFlangeLength(4),
        maximumLength: 800,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 1.2,
        innerRadius: 1.1,
        minFlangeLength: calculateMinFlangeLength(5),
        maximumLength: 800,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 1.5,
        innerRadius: 1.3,
        minFlangeLength: calculateMinFlangeLength(5.5),
        maximumLength: 1000,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        // 1.6 uses the 1.5 die row.
        thickness: 1.6,
        innerRadius: 1.3,
        minFlangeLength: calculateMinFlangeLength(5.5),
        maximumLength: 1000,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 2,
        innerRadius: 2,
        minFlangeLength: calculateMinFlangeLength(8.5),
        maximumLength: 800,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 2.5,
        innerRadius: 2.6,
        minFlangeLength: calculateMinFlangeLength(11),
        maximumLength: 800,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 3,
        innerRadius: 3,
        minFlangeLength: calculateMinFlangeLength(13),
        maximumLength: 800,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 4,
        innerRadius: 4,
        minFlangeLength: calculateMinFlangeLength(17.5),
        maximumLength: 300,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 5,
        innerRadius: 5,
        minFlangeLength: calculateMinFlangeLength(22),
        maximumLength: 300,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    },
    {
        thickness: 6,
        innerRadius: 6.5,
        minFlangeLength: calculateMinFlangeLength(18),
        maximumLength: 300,
        angle: 90,
        maxCornerRadius: 0,
        tailLength: 0
    }
];
const ir11BendTools = [
    {
        thickness: 0.9,
        innerRadius: 11,
        minFlangeLength: 10,
        maximumLength: 200,
        angle: 63,
        maxCornerRadius: 5,
        tailLength: 0,
        minTongueLength: calculateMinTongueLength(0.9, 11)
    },
    {
        thickness: 1.0,
        innerRadius: 11,
        minFlangeLength: 10,
        maximumLength: 200,
        angle: 63,
        maxCornerRadius: 5,
        tailLength: 0,
        minTongueLength: calculateMinTongueLength(1.0, 11)
    },
    {
        thickness: 1.2,
        innerRadius: 11,
        minFlangeLength: 10,
        maximumLength: 200,
        angle: 63,
        maxCornerRadius: 5,
        tailLength: 0,
        minTongueLength: calculateMinTongueLength(1.2, 11)
    },
    {
        thickness: 1.5,
        innerRadius: 11,
        minFlangeLength: 10,
        maximumLength: 200,
        angle: 63,
        maxCornerRadius: 5,
        tailLength: 0,
        minTongueLength: calculateMinTongueLength(1.5, 11)
    },
    {
        thickness: 1.6,
        innerRadius: 11,
        minFlangeLength: 10,
        maximumLength: 200,
        angle: 63,
        maxCornerRadius: 5,
        tailLength: 0,
        minTongueLength: calculateMinTongueLength(1.6, 11)
    },
    {
        thickness: 2.0,
        innerRadius: 11,
        minFlangeLength: 10,
        maximumLength: 200,
        angle: 63,
        maxCornerRadius: 5,
        tailLength: 0,
        minTongueLength: calculateMinTongueLength(2.0, 11)
    }
];
const ir5BendTools = [
    {
        thickness: 0.9,
        innerRadius: 5,
        minFlangeLength: 5.5,
        maximumLength: 400,
        angle: 55,
        maxCornerRadius: 5,
        tailLength: 5.56,
        minTongueLength: calculateMinTongueLength(0.9, 6.5)
    },
    {
        thickness: 1.0,
        innerRadius: 5,
        minFlangeLength: 5.5,
        maximumLength: 400,
        angle: 55,
        maxCornerRadius: 5,
        tailLength: 5.56,
        minTongueLength: calculateMinTongueLength(1.0, 6.5)
    },
    {
        thickness: 1.2,
        innerRadius: 5,
        minFlangeLength: 5.5,
        maximumLength: 400,
        angle: 55,
        maxCornerRadius: 5,
        tailLength: 5.56,
        minTongueLength: calculateMinTongueLength(1.2, 6.5)
    },
    {
        thickness: 1.5,
        innerRadius: 5,
        minFlangeLength: 5.5,
        maximumLength: 400,
        angle: 55,
        maxCornerRadius: 5,
        tailLength: 5.56,
        minTongueLength: calculateMinTongueLength(1.5, 6.5)
    },
    {
        thickness: 1.6,
        innerRadius: 5,
        minFlangeLength: 5.5,
        maximumLength: 400,
        angle: 55,
        maxCornerRadius: 5,
        tailLength: 5.56,
        minTongueLength: calculateMinTongueLength(1.6, 6.5)
    },
    {
        thickness: 2.0,
        innerRadius: 5,
        minFlangeLength: 8.5,
        maximumLength: 400,
        angle: 55,
        maxCornerRadius: 5,
        tailLength: 5.56,
        minTongueLength: calculateMinTongueLength(2.0, 6.5)
    }
];
const ninetyDegreeBendToolsByThickness = keyBy(ninetyDegreeBendTools, 'thickness');
const ir11BendToolsByThickness = keyBy(ir11BendTools, 'thickness');
const ir5BendToolsByThickness = keyBy(ir5BendTools, 'thickness');
export const kFactor = {
    [RawMaterial.aluminium]: 0.5,
    [RawMaterial.ss304]: 0.38,
    [RawMaterial.ss316]: 0.38,
    [RawMaterial.brass]: 0.44
};
const tensileStrength = {
    [RawMaterial.ss304]: 700,
    [RawMaterial.ss316]: 690,
    [RawMaterial.brass]: 360,
    [RawMaterial.aluminium]: 250
};
const dieVSizeByThickness = {
    0.55: 4,
    0.9: 6,
    1: 6,
    1.2: 7,
    1.5: 8,
    1.6: 8,
    2: 12,
    2.5: 16,
    3: 18,
    4: 25,
    5: 32,
    6: 40
};
const toolingLengthByThickness = {
    0.55: 800,
    0.9: 800,
    1: 800,
    1.2: 800,
    1.5: 1000,
    1.6: 1000,
    2: 800,
    2.5: 800,
    3: 800,
    4: 300,
    5: 300,
    6: 300
};
const machineTonnageLimit = 40;
const realworldFactor = 1.3;
const forceCoefficient = 1.42;
const gravity = 9.80665;
export const calculateMaxBendLength = (thickness, material)=>{
    const vSize = dieVSizeByThickness[thickness];
    const toolingLength = toolingLengthByThickness[thickness];
    if (vSize == null || toolingLength == null) {
        return null;
    }
    const tonnageLimitedLength = machineTonnageLimit * 1000 * vSize * gravity / (forceCoefficient * tensileStrength[material] * thickness * thickness * realworldFactor);
    return Math.floor(Math.min(toolingLength, tonnageLimitedLength));
};
export function calculateBendLengths(innerRadius, outerRadius, bendAngleDeg, material, tailLength) {
    const thickness = outerRadius - innerRadius;
    const neutralRadius = innerRadius + kFactor[material] * thickness;
    const bendAngleRad = bendAngleDeg * Math.PI / 180.0;
    const insideLength = innerRadius * bendAngleRad + tailLength;
    const neutralLength = neutralRadius * bendAngleRad + tailLength;
    const outsideLength = outerRadius * bendAngleRad + tailLength;
    // Calculate x coordinates of the last point on the outside arc
    const xArcLength = outerRadius * Math.sin(bendAngleRad);
    const xTailLength = tailLength * Math.cos(bendAngleRad);
    const xLength = xArcLength + xTailLength;
    return {
        neutralRadius,
        insideLength,
        neutralLength,
        outsideLength,
        xLength
    };
}
// Do not use start and end. Instead calculate relative coordinates.
// Output from this function should also be how long the bend is on X axis.
// eslint-disable-next-line max-params
export function calculateCustomBendLine(currentRadius, neutralRadius, maxAngleDeg, bendDirection, zeroPoint, currentPoint) {
    const toRight = currentPoint.x > zeroPoint.x;
    const sign = toRight ? 1 : -1;
    const maxAngleRad = maxAngleDeg * Math.PI / 180;
    const maxNeutralBendLength = maxAngleRad * neutralRadius;
    const maxCurrentBendLength = maxAngleRad * currentRadius;
    // We need to calculate the length for current radius, because input points are taken from a flat plate.
    // Bend goes from zero angle up to max angle. The rest of the plate is tail. Tail length is not affected by current radius.
    const radiusRatio = currentRadius / neutralRadius;
    const currentBendLength = Math.min(maxCurrentBendLength, Math.abs(currentPoint.x - zeroPoint.x) * radiusRatio);
    const currentTailLength = Math.max(0, Math.abs(currentPoint.x - zeroPoint.x) - maxNeutralBendLength);
    const bendProgress = Math.min(currentBendLength / maxCurrentBendLength, 1);
    const angleRad = maxAngleRad * bendProgress;
    const currentBendX = currentRadius * Math.sin(angleRad);
    const currentBendZ = currentRadius * (1 - Math.cos(angleRad));
    const currentTailx = currentTailLength * Math.cos(maxAngleRad);
    const currentTailZ = currentTailLength * Math.sin(maxAngleRad);
    const newX = (currentBendX + currentTailx) * sign;
    const newZ = (currentBendZ + currentTailZ) * (bendDirection === BendDirection.Front ? -1 : 1);
    return {
        x: zeroPoint.x + newX,
        y: currentPoint.y,
        z: zeroPoint.z + newZ
    };
}
export const bendData = {
    // Ninety degree bend
    d90: {
        name: '90°',
        radius: null,
        getTool: (thickness, material)=>{
            const tool = ninetyDegreeBendToolsByThickness[thickness] ?? null;
            if (!tool || !material) {
                return tool;
            }
            const maxBendLength = calculateMaxBendLength(thickness, material);
            if (maxBendLength == null) {
                return tool;
            }
            return {
                ...tool,
                maximumLength: Math.min(tool.maximumLength, maxBendLength)
            };
        },
        calculateFlatLength: (innerLength1, innerLength2, thickness, innerRadius, material)=>{
            // return calculateFlatLength(innerLength1, innerLength2, thickness, innerRadius, material, 90)
            const { neutralLength } = calculateBendLengths(innerRadius, innerRadius + thickness, 90, material, 0);
            const flatArmLenght1 = innerLength1 - innerRadius;
            const flatArmLenght2 = innerLength2 - innerRadius;
            return flatArmLenght1 + flatArmLenght2 + neutralLength;
        },
        /**
     * Calculates the arm length of a bent plate when arms are split evenly
     * @param {number} flatLength - total flat length of the plate (mm)
     * @param {number} thickness - thickness of the plate (mm)
     * @param {number} innerRadius - inner radius of the bend (mm)
     * @param {number} material - material of the plate
     * @returns {number} armLength - length of each arm (mm)
     */ calculateArmLength: (flatLength, thickness, innerRadius, material)=>{
            const angleRad = Math.PI / 2 // 90°
            ;
            const neutralRadius = innerRadius + kFactor[material] * thickness;
            const bendAllowance = angleRad * neutralRadius;
            const flatArmLength = (flatLength - bendAllowance) / 2;
            const innerLength = flatArmLength + innerRadius;
            const outerLength = flatArmLength + innerRadius + thickness;
            return {
                flatArmLength,
                innerLength,
                outerLength
            };
        }
    },
    ir11: {
        name: 'R11',
        radius: 11,
        minTongueLength: 12,
        getTool: (thickness)=>{
            return ir11BendToolsByThickness[thickness] ?? null;
        }
    },
    ir5: {
        name: 'R5',
        radius: 6.5,
        minTongueLength: 9,
        getTool: (thickness)=>{
            return ir5BendToolsByThickness[thickness] ?? null;
        }
    }
};

//# sourceMappingURL=bend-data.js.map